import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { MODAL_CONTENT_CLASS_NAMES } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery } from '@noths/polaris-client-styles';
import { createGlobalStyle, css } from 'styled-components';

import { BASKET_MODAL_CONTENT_LABEL } from '../copy';

const { fonts, responsiveText, spacing } = theme;

export const BasketModalGlobalStyles = createGlobalStyle`
  .${MODAL_CONTENT_CLASS_NAMES.base} {
    ${mediaQuery(
      { min: minBreakpoints.L },
      css`
        &[aria-label='${BASKET_MODAL_CONTENT_LABEL}'] {
          grid-column: 3 / -3;
        }
      `,
    )}
  }
`;

export const headerSection = css`
  display: flex;
  margin: 0;
  column-gap: ${spacing.md}px;

  h2 {
    margin: 0;
    ${responsiveText.BODY.MD};
    font-weight: 400;
  }
`;

const BODY_CONTENT_BORDER_RADIUS = 21;

export const bodyContent = css`
  margin: ${spacing.xl}px;
  border-radius: ${BODY_CONTENT_BORDER_RADIUS}px;
  background-color: var(--brand-bluple-10);
`;

export const addedProductSection = css`
  border-radius: ${BODY_CONTENT_BORDER_RADIUS}px;
  border: solid 1px var(--neutral-black-30);
  padding: ${spacing.xl}px;
  ${responsiveText.BODY.XS};
  background-color: var(--neutral-white-base);
`;

export const contentSection = css`
  padding: ${spacing.md}px;
  ${responsiveText.BODY.XS};
`;

export const buttonContainer = css`
  width: 100%;
  display: flex;
  flex-direction: column;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      flex-basis: 500px;
      flex-direction: row;
    `,
  )}
`;

export const goToBasketButton = css`
  margin-left: ${spacing.xxl}px;

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      margin-top: ${spacing.sm}px;
      margin-left: 0;
    `,
  )}
`;

export const summary = css`
  margin-bottom: ${spacing.sm}px;
  ${responsiveText.BODY.XS};
  text-align: center;

  p {
    display: inline;
    margin-right: ${spacing.sm}px;
  }

  b {
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  }

  s {
    margin-left: ${spacing.xs}px;
    color: var(--neutral-black-40);
  }

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      text-align: left;
    `,
  )}
`;

export const breakdownWrapper = css`
  margin-top: ${spacing.md}px;
  ${responsiveText.BODY.XS};
  flex-basis: 200px;
`;

export const productInfo = css`
  display: flex;
  flex: 1;
  flex-basis: 50%;
  align-self: flex-start;

  p {
    margin: ${spacing.base}px 0;
  }
`;

export const productImage = css`
  margin-right: ${spacing.md}px;
  border-radius: 10px;
`;
